if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}


/*
if (!customElements.get('sticky-atc-panel')) {
  function listenElementVisibility(element, callback) {
    if (!element || typeof callback !== 'function') {
      throw new Error('Invalid arguments: element and callback function are required')
    }

    // Create the IntersectionObserver with a rootMargin of 150px on all sides
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Notify about visibility changes based on `isIntersecting`
          callback(entry.isIntersecting, entry.boundingClientRect)
        })
      },
      {
        rootMargin: '150px', // Adds a 150px margin around the viewport
      }
    )

    // Start observing the element
    observer.observe(element)

    // Return a function to allow stopping observation
    return () => observer.disconnect()
  }

  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super()

      this.productSection = this.closest('.cc-main-product')
      this.productInfo = this.productSection.querySelector('.product-info')
      this.productForm = this.productSection.querySelector('product-form')

      this._scrolledHalfFold = false
      this._scrollHandler = StickyAtcPanel.handleScroll.bind(this)

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents2()
      }

      requestAnimationFrame(() => {
        this._scrollHandler()
      })
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', this._scrollHandler)
    }

    bindEvents2() {
      listenElementVisibility(this.productForm, (visible, rect) => {
        if (theme.mediaMatches.md) {
          // hide on big screens
          this.show(false)
          return
        }

        const top = rect.top - window.innerHeight
        console.log('visible', visible, parseInt(rect.top, 10), parseInt(top, 10))
        if (this._scrolledHalfFold) {
          // show when not visible on the screen
          this.show(!visible)
        }
      })

      window.addEventListener('scroll', this._scrollHandler)
    }

    show(show) {
      if (show) {
        this.classList.remove('sticky-atc-panel--out')
      } else {
        this.classList.add('sticky-atc-panel--out')
      }
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0)
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting)
          }
        })
      })

      if (this.productForm) observer.observe(this.productForm)
      if (this.productInfo) observer.observe(this.productInfo)

      window.addEventListener('scroll', this._scrollHandler)
    }

    // Watches for a scroll to the bottom of the pag
    static handleScroll() {
      const viewportHeight = window.innerHeight
      const scrolledHalfFold = window.scrollY > (viewportHeight / 2)

      this._scrolledHalfFold = scrolledHalfFold
      if (!theme.mediaMatches.md) {
        if (!scrolledHalfFold) {
          this.show(false)
        }
      }

      document.body.style.setProperty('--scroll-y', `${window.scrollY}px`)
      document.body.setAttribute('data-scrolled-fold-half', scrolledHalfFold.toString())
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      )
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel)
}

 */